export default {
  name: 'HeaderForPC',
  props: {}
};